import { createContext, useContext } from 'react';

import type { Me } from '@/api/types';

export type AuthStatus = 'loading' | 'anonymous' | 'authenticated';

export type LoginResult = { status: 'done' } | { status: 'mfa'; mfaToken: string };

export interface AuthContextValue {
  status: AuthStatus;
  user: Me | null;
  /** Motif de la dernière déconnexion forcée (session expirée…). */
  sessionMessage: string | null;
  login: (username: string, password: string) => Promise<LoginResult>;
  /** `remember` : ne plus demander le code sur cet appareil pendant 30 jours. */
  verifyMfa: (mfaToken: string, code: string, remember?: boolean) => Promise<void>;
  logout: () => Promise<void>;
  reloadUser: () => Promise<Me | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth doit être utilisé dans <AuthProvider>.');
  return value;
}
